import React from 'react';
import { PropTypes as PT } from 'prop-types';
import classes from './SettingsModal.module.scss';

class SettingsModalNavListItem extends React.PureComponent {
  constructor(props) {
    super(props);
    this.handleTabChange = this.tabChangeHandler.bind(this);
  }

  tabChangeHandler() {
    this.props.handleChangeTab(this.props.tabName);
  }

  render() {
    return (
      <li>
        <button
          onClick={this.handleTabChange}
          className={(this.props.isActiveTab) ? classes.activeTab : null}
        >
          {this.props.children}
        </button>
      </li>
    );
  }
}

SettingsModalNavListItem.propTypes = {
  tabName: PT.string.isRequired,
  children: PT.element.isRequired,
  isActiveTab: PT.bool.isRequired,
  handleChangeTab: PT.func.isRequired
};

export default SettingsModalNavListItem;
